module.exports = __webpack_public_path__ + "static/media/collage_payroll_illustration@2x.a2dd5d2e.png";